// extracted by mini-css-extract-plugin
var _1 = "featuredQuote_cIv2m";
export { _1 as "featuredQuote" }
